export default __webpack_public_path__ + "static/media/closing-img.6d78db89.png";